import { render, staticRenderFns } from "./no-delivery-warning.vue?vue&type=template&id=6f53a76a&"
import script from "./no-delivery-warning.vue?vue&type=script&lang=js&"
export * from "./no-delivery-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f53a76a')) {
      api.createRecord('6f53a76a', component.options)
    } else {
      api.reload('6f53a76a', component.options)
    }
    module.hot.accept("./no-delivery-warning.vue?vue&type=template&id=6f53a76a&", function () {
      api.rerender('6f53a76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/catalog/no-delivery-warning.vue"
export default component.exports